import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=694f009e&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=694f009e&lang=less&scoped=true"

import exportComponent from "C:\\webproject\\mofa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694f009e"]])

export default __exports__